import React, { FC } from "react";

interface ProfileImgProps {
  url: string;
  width?: number;
  height?: number;
}

const ProfileImg: FC<ProfileImgProps> = ({
  url,
  width = 100,
  height = 100,
}) => (
  <img
    style={{ width: `${width}px`, height: `${height}px` }}
    className="rounded-full object-cover"
    src={url}
  />
);

export default ProfileImg;
